"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var typography_1 = require("./typography");
var grid_1 = require("./grid");
var layout_1 = require("../util/layout");
var LabelRow = (0, styled_components_1.default)(grid_1.Container)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  // box-shadow: inset 0px -1px 0px ", ";\n"], ["\n  // box-shadow: inset 0px -1px 0px ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.grayBorder;
});
var LabelWrapper = (0, styled_components_1.default)(grid_1.Item)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &:first-child {\n    padding-left: 0;\n  }\n"], ["\n  &:first-child {\n    padding-left: 0;\n  }\n"])));
var TabLabel = styled_components_1.default.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n  ", "\n  padding: 0;\n  border: none;\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n\n  font-weight: ", ";\n\n  background-color: ", ";\n  color: ", ";\n\n  box-shadow: inset 0px ", " 0px\n    ", ";\n"], ["\n  cursor: pointer;\n  ", "\n  padding: 0;\n  border: none;\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n\n  font-weight: ", ";\n\n  background-color: ", ";\n  color: ", ";\n\n  box-shadow: inset 0px ", " 0px\n    ", ";\n"])), (0, typography_1.fontSize)(1), (0, layout_1.space)(2.75), (0, layout_1.space)(2), (0, layout_1.space)(2), function (_a) {
    var active = _a.active;
    return (active ? 500 : 400);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme, active = _a.active;
    return active ? theme.colors.primary : theme.colors.gray;
}, function (_a) {
    var theme = _a.theme, active = _a.active;
    return (active ? '-2px' : '-1px');
}, function (_a) {
    var theme = _a.theme, active = _a.active;
    return (active ? theme.colors.primary : 'rgba(0,0,0,0)');
});
var TabCount = styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  background-color: ", ";\n  color: ", ";\n  margin-left: ", ";\n  border-radius: 100%;\n  font-weight: 400;\n  width: 1.25rem;\n  height: 1.25rem;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  ", "\n  background-color: ", ";\n  color: ", ";\n  margin-left: ", ";\n  border-radius: 100%;\n  font-weight: 400;\n  width: 1.25rem;\n  height: 1.25rem;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])), (0, typography_1.fontSize)(0.875), function (_a) {
    var theme = _a.theme, active = _a.active;
    return active ? theme.colors.primary : theme.colors.gray;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, (0, layout_1.space)(1));
var Tabs = function (_a) {
    var tabs = _a.tabs, activeTab = _a.activeTab, setActiveTab = _a.setActiveTab, props = __rest(_a, ["tabs", "activeTab", "setActiveTab"]);
    return (react_1.default.createElement(LabelRow, __assign({}, props, { align: "flex-end" }), tabs.map(function (t, idx) { return (react_1.default.createElement(LabelWrapper, { key: "tab-".concat(idx), px: 1 },
        react_1.default.createElement(TabLabel, { onClick: function () { return setActiveTab(idx); }, active: activeTab === idx },
            react_1.default.createElement(grid_1.Container, { align: "flex-end", justify: "center" },
                t.label,
                t.count !== undefined ? (react_1.default.createElement(TabCount, { active: activeTab === idx }, t.count)) : null)))); })));
};
exports.default = Tabs;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Tabs.js.map